import { LazyPage, OAuth2 } from './-components';
import { createFileRoute } from '@tanstack/react-router';

function OAuth2Route() {
  return (
    <LazyPage>
      <OAuth2 />
    </LazyPage>
  );
}

export const Route = createFileRoute('/oauth2/$')({
  component: OAuth2Route,
});
